import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'StudentsListfilter'
})
export class FilterPipeStudents implements PipeTransform {
    transform(students: any, term?: any): any {
        if (term === undefined) return students;
        if (term === null) return students;

        if (students != null) {
            return students.filter(function (student) {
                if (student.name != undefined)
                    if (student.name.toString().toLowerCase().includes(term.toLowerCase()))
                        return student;
                if (student.email != undefined)
                    if (student.email.toString().toLowerCase().includes(term.toLowerCase()))
                        return student;
            })
        }



    }
}


// WEBPACK FOOTER //
// ./src/pages/schools/students-list/filter.pipe.ts